export const Theme = {
    typography: {
      fontFamily: ["ProximaNovaAltLight-Regular"]
    },
    palette: {
      primary: {
        main: "#008a52"
      }
    },
    overrides: {
      MuiButton: {
        root: {
          // maxWidth: 300
        },
        containedPrimary: {
          color: "#fff"
        },
        text: {
          color: "#008a52"
        }
      },
      MuiListItemIcon: {
        root: {
          minWidth: 30
        }
      },
      MuiTypography: {
        colorTextSecondary: {
          color: "#fff"
        }
      }
    }
  };